import useObservabilityConfig from '../public/useObservabilityConfig';
/**
 * @see https://sail.stripe.me/apis/observability/useProject
 */ export default function useProject() {
    return useObservabilityConfig().project;
}

//# sourceMappingURL=useProject.js.map